import React from "react";
import "./Spinner.css";
const Spinner = () => (
  <div className="spinner_container">
    <div className="loader"></div>
  </div>
);

export default Spinner;
